<header class="layout-header">
  <div class="layout-header__title">{{ layoutService.pageTitle() }}</div>
  <div class="layout-header__tagline">
    @if (config().taglineUrl) {
      <img class="layout-header__tagline-image" [src]="config().taglineUrl" [alt]="config().taglineAltText" />
    }
  </div>

  @if (config().companyLogoUrl) {
    <img
      class="layout-header__company-logo"
      [style.--company-logo-height]="config().companyLogoHeight"
      [src]="config().companyLogoUrl"
      [alt]="config().companyLogoAltText"
    />
  }
</header>
